export const INSPECTION_PRESET_ID = 'inspection';

export const DEFAULT_LABOR_PRESETS = [
  {
    id: INSPECTION_PRESET_ID,
    description: 'Inspection',
    amount: 0,
  },
];

export function normalizeLaborPresets(presets) {
  return (presets || [])
    .map((p) => {
      const amount = Number(p.amount);
      return {
        id: p.id || '',
        description: (p.description || '').trim(),
        amount: Number.isFinite(amount) ? amount : 0,
      };
    })
    .filter((p) => p.description);
}

export function resolveLaborPresets(presets, removedDefaultIds = []) {
  const normalized = normalizeLaborPresets(presets);
  const removed = new Set(removedDefaultIds || []);
  const hasInspection = normalized.some((p) =>
    p.id === INSPECTION_PRESET_ID ||
    p.description.toLowerCase() === 'inspection'
  );

  if (!removed.has(INSPECTION_PRESET_ID) && !hasInspection) {
    return [
      { ...DEFAULT_LABOR_PRESETS[0] },
      ...normalized,
    ];
  }
  return normalized;
}

export function isDefaultLaborPreset(preset) {
  return preset?.id === INSPECTION_PRESET_ID;
}
